/* eslint-disable */
export default {
  unknown: 'Sconosciuto',
  anonymous: 'Numero anonimo',
  activeCall: 'Chiamata attiva',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
